import settings from '../settings'
import { format } from 'date-fns'
import { enUS, zhCN, ru } from 'date-fns/locale'

const locales = { enUS, zhCN, ru }

export default function (date, formatStr = 'PP') {
  return format(date, formatStr, {
    locale: locales[settings.LANG]
  })
}
